import { createContext, useContext, useMemo, useState } from 'react';

type StartOnCallAlertMessageCtxState = {
  groupIds: number | undefined;
  userIds: Set<number>;

  setGroupIds: React.Dispatch<React.SetStateAction<number | undefined>>;
  setUserIds: (set: Set<number>) => void;

  onCallAlertMessageText: string;
  setOnCallAlertMessageText: (text: string) => void;

  subject: string;
  setSubject: React.Dispatch<React.SetStateAction<string>>;
};

const StartOnCallALertMessageCtxDefaultValue: StartOnCallAlertMessageCtxState = {
  groupIds: undefined,
  userIds: new Set(),

  setGroupIds: () => {},
  setUserIds: () => {},

  onCallAlertMessageText: '',
  setOnCallAlertMessageText: () => {},

  subject: '',
  setSubject: () => {},
};

const StartOnCallALertMessageCtx = createContext<StartOnCallAlertMessageCtxState>(
  StartOnCallALertMessageCtxDefaultValue
);

export const TEXT_LENGTH_LIMIT = 300;

export const useStartOnCallAlertMessageCtx = () => useContext(StartOnCallALertMessageCtx);

type StartOnCallAlertMessageCtxProviderProps = {
  children: React.ReactNode;
};
export const StartOnCallAlertMessageCtxProvider = (
  props: StartOnCallAlertMessageCtxProviderProps
) => {
  const { children } = props;

  const [groupIds, setGroupIds] = useState<number>();

  const [userIds, setUserIds]: [Set<number>, (set: Set<number>) => void] = useState(new Set());

  const [onCallAlertMessageText, setOnCallAlertMessageText] = useState<string>('');

  const [subject, setSubject] = useState<string>('');

  const setMessageText = (text: string) => {
    if (text.length <= TEXT_LENGTH_LIMIT) {
      setOnCallAlertMessageText(text);
    }
  };

  const value = useMemo(
    () => ({
      groupIds,
      userIds,
      subject,

      setGroupIds,
      setUserIds,
      setSubject,

      onCallAlertMessageText,
      setOnCallAlertMessageText: setMessageText,
    }),
    [groupIds, subject, onCallAlertMessageText, userIds]
  );
  return (
    <StartOnCallALertMessageCtx.Provider value={value}>
      {children}
    </StartOnCallALertMessageCtx.Provider>
  );
};
